import { VisuallyHidden } from "@radix-ui/react-visually-hidden"
import React, { useState } from "react"
import { Drawer } from "vaul"

import { useGetStartedModalStore } from "./store"
import { GetStartedModalMenuTab } from "./Tabs/Menu"
import { GetStartedModalRegisterTab } from "./Tabs/Register"
import { Color } from "../../../../constants/V2/color"
import ArrowIcon from "../../../elements/V2/Icons/ArrowIcon"
import CloseIcon from "../../../elements/V2/Icons/CloseIcon"

const GET_STARTED_MODAL_TABS = {
  menu: GetStartedModalMenuTab,
  register: GetStartedModalRegisterTab,
} as const

export type GetStartedModalTab = keyof typeof GET_STARTED_MODAL_TABS

export const GetStartedModal = () => {
  const { isGetStartedModalOpen, setIsGetStartedModalOpen } =
    useGetStartedModalStore()

  const [activeTab, setActiveTab] = useState<GetStartedModalTab>("menu")

  const Tab = GET_STARTED_MODAL_TABS[activeTab]

  return (
    <Drawer.Root
      open={isGetStartedModalOpen}
      direction="bottom"
      onOpenChange={(open) => {
        setIsGetStartedModalOpen(open)
      }}
    >
      <Drawer.Portal>
        <Drawer.Overlay className="fixed -top-28 bottom-0 left-0 right-0 z-50 bg-black/30" />
        <VisuallyHidden>
          <Drawer.Description>Get started</Drawer.Description>
        </VisuallyHidden>
        <Drawer.Content className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="relative z-20 max-h-[90vh] w-[90vw] overflow-y-auto rounded-10 bg-white sm:max-w-[460px]">
            {activeTab !== "menu" && (
              <button
                onClick={() => setActiveTab("menu")}
                className="absolute left-20 top-[28px]"
              >
                <ArrowIcon width="12px" height="12px" className="rotate-180" />
              </button>
            )}
            <Drawer.Trigger className="absolute right-20 top-[19px]">
              <CloseIcon
                width="30px"
                height="30px"
                hideBorder
                strokeWidth="2"
                strokeColor={Color.Black}
              />
            </Drawer.Trigger>

            <Tab setActiveTab={setActiveTab} />
          </div>
          <Drawer.Close className="fixed inset-0" />
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
